<div class="image-cropper-dialog pdf-image-uploader">
  <div class="div image-cropper-header pl-5p">
    <p class="mb-0 font-600 font-14 font-gray-45">
      <i class="far fa-file-image font-20"></i>
      <span class="pl-1">Add company logo</span>
      <span class="close-dialog float-right">
        <i class="fal fa-times" (click)="closeModal()"></i>
      </span>
    </p>
  </div>

  <div class="div image-cropper-body">
    <div class="pdf-img-tabs">
      <p-tabView (onChange)="selectedTab = $event.index">

        <!-- Streched -->
        <p-tabPanel [selected]="selectedTab === 0" header="Stretched" leftIcon="fas fa-expand-arrows-alt">
          <div class="strecthed-img">
            <img [src]="pdfImg" alt="">
          </div>
        </p-tabPanel>

        <!-- Cropped -->
        <p-tabPanel [selected]="selectedTab === 1" [selected]="true" header="Cropped" leftIcon="fas fa-crop">
          <image-cropper [imageChangedEvent]="imageChangedEvent" [imageFile]="image" [maintainAspectRatio]="true"
            [aspectRatio]="5.5" [cropperMinWidth]="600" [cropperMinHeight]="130" format="png"
            (imageCropped)="imageCropped($event)">
          </image-cropper>
        </p-tabPanel>

        <!-- Best Fit -->
        <p-tabPanel [selected]="selectedTab === 2" header="Best fit" leftIcon="fas fa-compress-arrows-alt">
          <div class="best-fit-img">
            <img [src]="pdfImg" alt="">
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>

  <div class="div image-cropper-footer text-right">
    <div class="ui-g-12 part-footer">
      <button class="btn btn-border pointer btn-submit mr-1" (click)="closeModal()">Cancel</button>
      <button class="btn btn-primary btn-submit" (click)="saveImage()">Save</button>
    </div>
  </div>
</div>
